import donationApi from "../../../apis/donationApi";
import styles from "./District.module.scss";

import { useEffect, useState } from "react";

interface DistrictProps {
  district: any;
  handleChangeDistrict: (districtID: string) => void;
  reload: boolean;
  isSelected?: boolean;
  drivers?: any[];
}

const District = (props: DistrictProps) => {
  const [totalOrders, setTotalOrders] = useState<number>(0);
  const [assignedOrders, setAssignedOrders] = useState<number>(0);
  const isDriver = localStorage.getItem("userRole") === "driver";
  const driverId = localStorage.getItem("driverId");

  useEffect(() => {
    (async () => {
      try {
        // Query orders in this district to determine driver assignment progress
        const res = await donationApi.getDonations({
          filter: {
            provinceId: "202",
            shippingTypeId: "11123",
            statuses: ["new", "confirm", "processing"],
            districtId: props.district.districtId,
            ...(isDriver && driverId ? { driverId } : {}),
          },
          paging: {
            offset: 0,
            limit: 100,
          },
        });

        if (res.data.code === 0) {
          let list = res.data.data.userDonations || [];
          if (isDriver && driverId) {
            list = list.filter((item: any) => item.driverId === driverId);
          }
          setTotalOrders(list.length);

          const assignedCount = list.filter((item: any) =>
            item.driverId &&
            item.driverId.trim() !== "" &&
            (!props.drivers || props.drivers.length === 0 || props.drivers.some((d: any) => d.id === item.driverId && d.status !== "DISABLED"))
          ).length;
          setAssignedOrders(assignedCount);
        }
    } catch (error) {
      console.log(error);
    }
  })();
}, [props.reload, props.district.districtId, isDriver, driverId, props.drivers]);

  const handleDistrict = () => {
    props.handleChangeDistrict(props.district.districtId);
  };

  if (!totalOrders || totalOrders === 0) {
    return null;
  }

  // For driver: keep clean default styling and NO status badge
  // For admin: 3 distinct colors based on driver assignment progress:
  // 1. Đã giao/gán hết đơn cho tài xế (100%): Màu xanh lá (#c8e6c9 / #2e7d32)
  // 2. Đang giao dở chưa hết đơn (assigned > 0 nhưng < total): Màu vàng cam (#ffe0b2 / #e65100)
  // 3. Chưa giao đơn nào cho tài xế (assigned == 0): Màu xanh xám mặc định (#dee5f8 / #1e293b)
  let bgColor = "#dee5f8";
  let textColor = "#1e293b";
  let statusBadge = "";
  let badgeBg = "";

  if (!isDriver) {
    if (assignedOrders === totalOrders) {
      bgColor = "#c8e6c9"; // Đã gán hết
      textColor = "#1b5e20";
      statusBadge = "Đã gán hết";
      badgeBg = "#2e7d32";
    } else if (assignedOrders > 0) {
      bgColor = "#ffe0b2"; // Đang giao dở
      textColor = "#e65100";
      statusBadge = `Đang giao (${assignedOrders}/${totalOrders})`;
      badgeBg = "#f57c00";
    } else {
      bgColor = "#dee5f8"; // Chưa giao đơn nào
      textColor = "#283593";
      statusBadge = "Chưa gán";
      badgeBg = "#5c6bc0";
    }
  }

  return (
    <div
      className={styles.districtIt}
      onClick={handleDistrict}
      style={{
        backgroundColor: bgColor,
        color: textColor,
        border: props.isSelected ? "2px solid #1976d2" : "1px solid rgba(0,0,0,0.06)",
        borderRadius: "6px",
        margin: "6px 8px",
        padding: "8px 12px",
        transition: "all 0.2s ease",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontWeight: 600, fontSize: "14px" }}>
          {props.district["districtName"]} ({totalOrders} đơn)
        </span>
        {!isDriver && statusBadge && (
          <span
            style={{
              fontSize: "11px",
              padding: "2px 6px",
              borderRadius: "4px",
              backgroundColor: badgeBg,
              color: "#ffffff",
              fontWeight: "bold",
            }}
          >
            {statusBadge}
          </span>
        )}
      </div>
    </div>
  );
};

export default District;
